// extracted by mini-css-extract-plugin
export default {"zoomModal":"O5-z","image":"P5-z","button":"Q5-z","isOverlayShown":"R5-z"};